'use client';

import { useEffect } from 'react';
import { ADTRACE_APP_TOKEN, ADTRACE_ENVIRONMENT } from './constants';
let hasInitialized = false;
const getQueryParam = (name: string) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
};
export const AdTraceScript = () => {
  useEffect(() => {
    if (hasInitialized || !ADTRACE_APP_TOKEN) return;
    hasInitialized = true;
    const initializeAdtrace = async () => {
      const {
        default: Adtrace
      } = await import('web-adtrace');
      Adtrace.initSdk({
        appToken: ADTRACE_APP_TOKEN,
        environment: ADTRACE_ENVIRONMENT,
        gps_adid: getQueryParam('gps_adid') ?? undefined
      });
    };
    initializeAdtrace();
  }, []);
  return null;
};